const AllReadIllustration: React.FC<{ size?: number }> = ({ size = 140 }) => (
  <svg className="allReadIllustrationSvg" width={size} height={size} viewBox="-12 -12 144 144" fill="none" aria-hidden="true">
    <style>
      {`
        .allReadIllustrationSvg .docShadow {
          opacity: 0.28;
          filter: blur(1px);
        }
        .allReadIllustrationSvg .docBack1 {
          transform: translate(-4px, 4px) rotate(-3deg);
          transform-origin: 60px 62px;
        }
        .allReadIllustrationSvg .docBack2 {
          transform: translate(4px, 2px) rotate(2deg);
          transform-origin: 60px 62px;
        }
        .allReadIllustrationSvg .flySheet {
          transform-origin: 60px 62px;
          animation: allReadFlySheet 4.3s linear infinite;
          pointer-events: none;
        }
        .allReadIllustrationSvg .checkBadge {
          transform-origin: 82px 88px;
          animation: allReadCheckPulse 10s ease-in-out infinite;
          filter: drop-shadow(0 0 0px rgba(76, 175, 80, 0.0));
        }
        @keyframes allReadFlySheet {
          0%, 58% {
            opacity: 0;
            transform: translate(-4px, 4px) rotate(-3deg) scale(0.99);
          }
          62% {
            opacity: 0.9;
            transform: translate(0, 0) rotate(0deg) scale(1);
          }
          93% {
            opacity: 0;
            transform: translate(42px, -30px) rotate(-17deg) scale(1.06);
          }
          100% {
            opacity: 0;
            transform: translate(-4px, 4px) rotate(-3deg) scale(0.99);
          }
        }
        @keyframes allReadCheckPulse {
          0%, 3% {
            transform: scale(1);
            filter: drop-shadow(0 0 0px rgba(76, 175, 80, 0));
          }
          5% {
            transform: scale(1.1);
            filter: drop-shadow(0 0 8px rgba(76, 175, 80, 0.45));
          }
          8%, 100% {
            transform: scale(1);
            filter: drop-shadow(0 0 0px rgba(76, 175, 80, 0));
          }
        }
      `}
    </style>

    <g className="docShadow">
      <rect x="24" y="24" width="70" height="85" rx="4" fill="#d6d6d6" />
    </g>

    <g className="docBack1">
      <rect x="25" y="20" width="70" height="85" rx="4" fill="#f4f4f4" stroke="#d9d9d9" strokeWidth="1.3" />
    </g>
    <g className="docBack2">
      <rect x="25" y="20" width="70" height="85" rx="4" fill="#f8f8f8" stroke="#d2d2d2" strokeWidth="1.3" />
    </g>
    <g className="flySheet">
      <rect x="25" y="20" width="70" height="85" rx="4" fill="#ffffff" stroke="#d7d7d7" strokeWidth="1.2" />
      <line x1="25" y1="40" x2="95" y2="40" stroke="#e3e3e3" strokeWidth="1" />
      <rect x="34" y="27" width="52" height="5" rx="2" fill="#d0d0d0" />
      <rect x="34" y="48" width="48" height="3" rx="1.5" fill="#e1e1e1" />
    </g>

    {/* Main newspaper / document */}
    <rect x="25" y="20" width="70" height="85" rx="4" fill="#f0f0f0" stroke="#ccc" strokeWidth="1.5" />
    <line x1="25" y1="40" x2="95" y2="40" stroke="#ddd" strokeWidth="1" />
    <rect x="34" y="27" width="52" height="5" rx="2" fill="#ccc" />
    <rect x="34" y="48" width="52" height="3" rx="1.5" fill="#ddd" />
    <rect x="34" y="57" width="44" height="3" rx="1.5" fill="#ddd" />
    <rect x="34" y="66" width="48" height="3" rx="1.5" fill="#ddd" />
    <rect x="34" y="75" width="38" height="3" rx="1.5" fill="#ddd" />
    <rect x="34" y="84" width="50" height="3" rx="1.5" fill="#ddd" />

    {/* Checkmark circle */}
    <circle className="checkBadge" cx="82" cy="88" r="18" fill="#4caf50" />
    <path d="M73 88l6 6 12-12" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none" />
  </svg>
);

export default AllReadIllustration;
